declare global {
  interface Window {
    fbq: (...args: any[]) => void
  }
}

export function trackLead(data?: Record<string, string>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Lead', data)
  }
}

export function trackContact() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Contact')
  }
}
